export const de: Record<string, string> = {
  'optimizer.weekNumber': 'KW {number}',
  'optimizer.previousWeek': 'Vorherige Woche',
  'optimizer.nextWeek': 'Nächste Woche',
  'optimizer.thisWeek': 'Diese Woche',
  'optimizer.scopeTitle': 'Was wird berücksichtigt?',
  'optimizer.closeDialog': 'Dialog schließen',
  'optimizer.durationHelp': 'Wie lange soll die Suche dauern?',
  'optimizer.itinerary': 'Fahrten im Tagesplan',
  'optimizer.driverFilter': 'Fahrer',
  'optimizer.allDrivers': 'Alle Fahrer',
  'optimizer.day': 'Wochentag',
  'optimizer.dayTours': '{count} Fahrten',
  'optimizer.noDayTours': 'Für diese Auswahl sind keine Fahrten geplant.',
  'optimizer.familyTotals': 'Wochenbilanz je Familie',

  'optimizer.searchDuration': "Suchdauer",
  'optimizer.duration.30': "30 Sekunden · schnell",
  'optimizer.duration.60': "1 Minute · empfohlen",
  'optimizer.duration.120': "2 Minuten · gründlicher",
  'optimizer.durationNote': "Maximale Zeit für die Plansuche. Warteschlange, Straßenfahrzeiten und abschließende Prüfungen kommen dazu. Mehr Suchzeit kann bessere Pläne finden; sie garantiert keine zusätzliche Ersparnis.",
  'optimizer.queueNote': "Der Rechenlauf wartet auf einen freien Platz. Die Suchzeit hat noch nicht begonnen.",
  'optimizer.searchElapsed': "Bisher {seconds} s · Suchbudget {budget} s",
  'optimizer.candidatesFound': "{count} mögliche Touren gefunden",
  'optimizer.finishingSearch': "Das Suchbudget ist aufgebraucht. Vorhandene Ergebnisse werden noch geprüft und gespeichert.",
  'optimizer.backgroundNote': "Du kannst dieses Fenster schließen. Die Berechnung läuft im Hintergrund weiter.",
  'optimizer.searchFinished': "Plansuche: {seconds} s von maximal {budget} s",
  'optimizer.searchFinishedLegacy': "Plansuche: {seconds} s",
  'optimizer.searchTruncated': "Suchraum begrenzt: Nicht alle möglichen Touren wurden untersucht. Eine längere Suche kann helfen; das weltbeste Ergebnis ist nicht garantiert.",
  'optimizer.processTitle': "Was passiert bei der Berechnung?",
  'optimizer.phase.routing': "Straßenfahrzeiten laden",
  'optimizer.phaseNote.routing': "Fahrzeiten zwischen den Orten werden geladen. Bereits gespeicherte Verbindungen werden wiederverwendet. Das Suchbudget läuft noch nicht.",
  'optimizer.phase.starting': "Plansuche startet",
  'optimizer.phaseNote.starting': "Die Fahrzeiten sind geladen. Die Gruppe wird an den Planer übergeben.",
  'optimizer.phase.candidates': "Mögliche Touren zusammenstellen",
  'optimizer.phaseNote.candidates': "Passende Fahrten werden anhand von Zeiten, Plätzen und Fahrbereitschaften gebildet. Eigene Familienfahrten werden für alle Wochentage zuerst berücksichtigt.",
  'optimizer.phase.coverage': "Alle Kinderwege absichern",
  'optimizer.phaseNote.coverage': "Zuerst wird ein vollständiger Ersatzplan gesucht. Erst wenn alle Wege gemeinsam abgedeckt sind, werden die drei Varianten optimiert.",
  'optimizer.phase.solo': "Alleinfahrten zum Vergleich berechnen",
  'optimizer.phaseNote.solo': "Für jeden Elternteil wird ermittelt, wie viel Fahrzeit und wie viele Einsätze beim Alleinfahren anfallen.",
  'optimizer.phase.baseline': "Kurzen Plan suchen",
  'optimizer.phaseNote.baseline': "Die gesamte Fahrzeit wird möglichst klein gehalten. Einzelne Eltern können dabei mehr Aufwand haben.",
  'optimizer.phase.optimal': "Optimalen Plan suchen",
  'optimizer.phaseNote.optimal': "Die gesamte Fahrzeit wird gesenkt. Niemand darf mehr Fahrzeit oder Einsätze als beim Alleinfahren haben; die Ersparnis darf unterschiedlich verteilt sein.",
  'optimizer.phase.fair': "Fairen Plan suchen",
  'optimizer.phaseNote.fair': "Die Belastung im Verhältnis zum Alleinfahren wird möglichst gleichmäßig verteilt.",
  'optimizer.phase.verifying': "Ergebnisse prüfen und aufbereiten",
  'optimizer.phaseNote.verifying': "Die gefundenen Pläne werden abschließend aufbereitet. Geprüfte Ergebnisse bleiben auch bei ausgeschöpftem Suchbudget erhalten.",
  'optimizer.phase.completed': "Ergebnisse speichern",
  'optimizer.phaseNote.completed': "Die Suche ist abgeschlossen. Die geprüften Pläne werden gespeichert.",

  'optimizer.fallback': 'Fallback-Plan',
  'optimizer.fallback.stale': 'Abdeckung erneut prüfen',
  'optimizer.fallback.staleNote': 'Die Abdeckung ist für die aktuellen Angaben nicht bestätigt. Bitte die Prüfung erneut starten.',
  'optimizer.fallback.ready': 'Alle Kinderwege gemeinsam abgesichert',
  'optimizer.fallback.blocked': 'Gruppe noch nicht abgesichert',
  'optimizer.fallback.blockedNote': 'Ohne vollständigen Fallback-Plan bleibt die gesamte Gruppe blockiert. Bitte Fahrbereitschaften ergänzen oder anpassen und neu prüfen. Niemand wird automatisch ausgeschlossen.',
  'optimizer.fallback.unknown': 'Die Suchgrenzen wurden erreicht. Das ist kein Nachweis, dass die Gruppe nicht vollständig versorgt werden kann.',
  'optimizer.fallback.diagnostic': 'Zwischenstand zur Fehlersuche: {served} von {total} Wegen. Dies ist kein freigegebener Gruppenplan.',
  'optimizer.fallback.legacy': 'Historischer Lauf ohne Fallback-Prüfung. Für die aktuelle Freigabe bitte neu berechnen.',

  'optimizer.guidance.summary': '{served} von {total} Wegen abgedeckt · {open} offen',
  'optimizer.guidance.title': 'So könnten weitere Wege abgedeckt werden',
  'optimizer.guidance.open': 'offen',
  'optimizer.guidance.pickupWindow': 'Benötigte Abholung',
  'optimizer.guidance.directWindow': 'Mögliches Zeitfenster für die direkte Fahrt',
  'optimizer.guidance.declared': 'Hinterlegt',
  'optimizer.guidance.none': 'keine Fahrbereitschaft',
  'optimizer.guidance.localEvidence': 'Hinweis zur geprüften Kombination; andere Kombinationen können ebenfalls eingeschränkt sein.',
  'optimizer.guidance.legacy': 'Für konkrete Hinweise bitte neu berechnen. Dieser gespeicherte Lauf enthält noch keine Ursachenanalyse.',
  'optimizer.guidance.partial': 'Die Analyse ist unvollständig. Angezeigte Verbesserungen sind geprüft; weitere Möglichkeiten wurden noch nicht vollständig untersucht.',
  'optimizer.guidance.unavailable': 'Die Ursachenanalyse ist derzeit nicht verfügbar. Der berechnete Plan bleibt erhalten.',
  'optimizer.guidance.preserved': 'Diese Vergleichspläne versorgen alle bisher abgedeckten Wege weiterhin. Einzelvorschläge sind Alternativen; ihre Verbesserungen dürfen nicht addiert werden.',
  'optimizer.guidance.package': 'Gemeinsam geprüfte Änderungen',
  'optimizer.guidance.adjust': 'Fahrbereitschaft anpassen',
  'optimizer.guidance.covered': 'Wege abgedeckt',
  'optimizer.guidance.newWindow': 'Zusätzliche Fahrbereitschaft',
  'optimizer.guidance.extra': '{minutes} zusätzliche Minuten Fahrbereitschaft insgesamt; das ist nicht die reine Fahrzeit.',
  'optimizer.guidance.newlyCovered': '{count} zusätzlich abgedeckte Wege ansehen',
  'optimizer.guidance.confirm': 'Bestätigung der Fahrbereitschaft erforderlich – Person und Auto müssen tatsächlich verfügbar sein.',
  'optimizer.guidance.next': 'Die Vorschläge beziehen sich auf diesen gespeicherten Eingabestand. Nach bestätigter Anpassung der Fahrbereitschaften den Wochenplan neu berechnen.',
  'optimizer.guidance.noRemedy': 'In den geprüften Varianten wurde keine zusätzliche Abdeckung gefunden. Weitere Fahrbereitschaften prüfen; das ist kein Nachweis, dass die Wege unmöglich sind.',
  'optimizer.planSection': 'Planberechnung',
  'optimizer.calculate': 'Abdeckung prüfen und Plan berechnen',
  'optimizer.historyLoading': 'Gespeicherte Pläne werden geladen …',
  'optimizer.starting': 'Berechnung wird gestartet …',
  'optimizer.queued': 'Berechnung wartet …',
  'optimizer.solving': 'Fahrzeiten und Wochenplan werden berechnet …',
  'optimizer.planFailed': 'Planberechnung fehlgeschlagen. Bitte erneut versuchen.',
  'optimizer.history': 'Alle gespeicherten Rechenläufe',
  'optimizer.history.choose': 'Rechenlauf auswählen',
  'optimizer.history.week': 'Woche ab {date}',
  'optimizer.history.readOnly': 'Historischer Plan – nur zur Ansicht',
  'optimizer.history.note': 'Dieser Plan zeigt die damals gespeicherten Angaben und Ergebnisse. Er bestätigt nicht die aktuelle Verfügbarkeit oder Abdeckung. Vor einer Nutzung die aktuellen Angaben prüfen und neu berechnen.',
  'optimizer.history.inputs': 'Gespeicherte Eingaben ansehen',
  'optimizer.history.unavailable': 'Nicht gespeichert',
  'optimizer.status.QUEUED': 'Wartet',
  'optimizer.status.RUNNING': 'Läuft',
  'optimizer.status.COMPLETED': 'Abgeschlossen',
  'optimizer.status.FAILED': 'Fehlgeschlagen',
  'optimizer.draftNote': 'Erst ein vollständiger Ersatzplan, dann die Optimierung. Bis dahin bleibt die gesamte Gruppe blockiert. Es werden keine Fahrten gebucht.',
  'optimizer.snapshot': 'Eingabestand vom {date}. Spätere Änderungen sind in diesem Plan nicht enthalten.',
  'optimizer.comparison': 'Vergleich',
  'optimizer.baseline': 'Kurzer Plan',
  'optimizer.fair': 'Fairer Plan',
  'optimizer.optimal': 'Optimaler Plan',
  'optimizer.totalSavings': 'Gesamte Fahrzeitersparnis',
  'optimizer.optimal.note': 'Möglichst viel Fahrzeit sparen, ohne dass ein Elternteil mehr Fahrzeit oder Fahreinsätze als beim Alleinfahren übernimmt. Die Ersparnis darf unterschiedlich verteilt sein.',
  'optimizer.optimal.noSavings': 'Unter diesen Bedingungen wurde keine Fahrzeitersparnis gefunden.',
  'optimizer.optimal.legacy': 'Für den optimalen Plan bitte neu berechnen. Dieser ältere Rechenlauf enthält noch keinen solchen Vergleich.',
  'optimizer.optimal.missing_reference': 'Optimaler Plan nicht berechenbar: Für mindestens ein Elternteil fehlt ein vollständiger Vergleich zum Alleinfahren.',
  'optimizer.optimal.infeasible': 'Optimaler Plan nicht verfügbar: Unter den geprüften Routen gibt es keinen vollständigen Plan ohne zusätzliche Fahrzeit oder Einsätze für einzelne Elternteile.',
  'optimizer.optimal.unknown': 'Optimaler Plan noch nicht gefunden: Das Rechenzeitlimit wurde erreicht. Bitte erneut berechnen.',
  'optimizer.optimal.not_calculated': 'Optimaler Plan noch nicht berechnet. Bitte die Planberechnung starten.',
  'optimizer.coverage': 'Eingeplante Kinderwege',
  'optimizer.driving': 'Fahrzeit',
  'optimizer.tours': 'Fahreinsätze',
  'optimizer.fairness': 'Ungleichverteilung ↓',
  'optimizer.openRequests': 'Offene Kinderwege',
  'optimizer.mon': 'Montag',
  'optimizer.tue': 'Dienstag',
  'optimizer.wed': 'Mittwoch',
  'optimizer.thu': 'Donnerstag',
  'optimizer.fri': 'Freitag',
  'optimizer.depart': 'Abfahrt',
  'optimizer.return': 'Rückkehr',
  'optimizer.pickup': 'einsteigen',
  'optimizer.dropoff': 'aussteigen',
  'optimizer.wait': 'Warten am Terminort',
  'optimizer.transfers': 'Verbindungsfahrten',
  'optimizer.family': 'Familie',
  'optimizer.coverageChecked': 'Vollständiger Fallback geprüft. Die Absicherung steht bereits fest; die Optimierung von Fahrzeit und Verteilung ist davon getrennt.',
  'optimizer.savings.title': 'Fahrzeit und Fahreinsätze pro Elternteil · ausgewählte Woche',
  'optimizer.savings.explanation': 'Wie wird die Ersparnis berechnet?',
  'optimizer.savings.note': 'Vergleich mit einem geprüften Plan, in dem jede Familie nur ihre eigenen Kinder fährt. Die Aufteilung auf die Eltern entspricht diesem Vergleichsplan; dafür werden deren Bereitschaftszeiten erweitert. Fahrzeit inklusive Verbindungsfahrten, ohne Warte- und Haltezeiten. Eine zusammenhängende Tour zählt als ein Fahreinsatz, auch mit mehreren Kindern oder mit Warten vor der Rückfahrt. Getrennte Hinbring- und Abholtouren zählen als zwei Einsätze. Ein anderer Elternteil kann durch die Verteilung mehr fahren.',
  'optimizer.savings.tripsOne': '{count} Fahreinsatz',
  'optimizer.savings.tripsMany': '{count} Fahreinsätze',
  'optimizer.savings.tripsSavedOne': '{count} Einsatz weniger',
  'optimizer.savings.tripsSavedMany': '{count} Einsätze weniger',
  'optimizer.savings.tripsExtraOne': '{count} Einsatz mehr',
  'optimizer.savings.tripsExtraMany': '{count} Einsätze mehr',
  'optimizer.savings.tripsEqual': 'Gleich viele Einsätze',
  'optimizer.savings.recalculateTrips': 'Für den Vergleich der Fahreinsätze bitte diesen älteren Plan neu berechnen.',
  'optimizer.savings.person': 'Elternteil',
  'optimizer.savings.solo': 'Ohne Fahrgemeinschaft',
  'optimizer.savings.planned': 'Im ausgewählten Plan',
  'optimizer.savings.saving': 'Ersparnis / Mehraufwand',
  'optimizer.savings.unavailable': 'Nicht berechenbar',
  'optimizer.savings.saved': '{minutes} min gespart',
  'optimizer.savings.extra': '{minutes} min Mehraufwand',
  'optimizer.savings.recalculate': 'Für diesen älteren Rechenlauf fehlen Einzelwerte. Bitte den Plan neu berechnen.',
  'optimizer.boundedSearch': 'Begrenzte Kandidatensuche, kein garantiertes globales Optimum.',
  'optimizer.title': 'Wochenplan berechnen',
  'optimizer.description': 'Eine Woche dieser Fahrgruppe gemeinsam planen und kurze, faire und optimale Fahrpläne vergleichen.',
  'optimizer.week': 'Planungswoche',
  'optimizer.monday': 'Bitte einen Montag wählen.',
  'optimizer.loading': 'Wochenplanung wird geprüft …',
  'optimizer.families': 'Familien', 'optimizer.children': 'Kinder', 'optimizer.requests': 'Kinderwege',
  'optimizer.drivers': 'Fahrer', 'optimizer.vehicles': 'Autos', 'optimizer.locations': 'Orte',
  'optimizer.fix': 'Vor der Berechnung bitte korrigieren',
  'optimizer.calls': '{count} Mapbox-Abfragen je Berechnung oder Export',
  'optimizer.cost': 'Die Vorschau ist kostenlos. Berechnung und Export laden kostenpflichtige Straßenfahrzeiten.',
  'optimizer.scope': 'Nur diese Gruppe wird betrachtet. Andere Gruppen, Live-Verkehr und persönliche Mautpräferenzen sind nicht berücksichtigt. Berechnete Pläne werden mit ihrem damaligen Eingabestand gespeichert.',
  'optimizer.download': 'JSON mit Fahrzeiten exportieren',
  'optimizer.running': 'Fahrzeiten werden berechnet. Das kann bis zu einer Minute dauern.',
  'optimizer.downloaded': 'Download gestartet. Die Datei kann direkt im Simulator importiert werden.',
  'optimizer.failed': 'Export fehlgeschlagen. Bitte erneut versuchen.',
  'optimizer.refresh': 'Vorschau erneut prüfen', 'optimizer.close': 'Schließen',
};
export const en: Record<string, string> = {
  'optimizer.weekNumber': 'Week {number}',
  'optimizer.previousWeek': 'Previous week',
  'optimizer.nextWeek': 'Next week',
  'optimizer.thisWeek': 'This week',
  'optimizer.scopeTitle': 'What is included?',
  'optimizer.closeDialog': 'Close dialog',
  'optimizer.durationHelp': 'How long should the search run?',
  'optimizer.itinerary': 'Daily itinerary',
  'optimizer.driverFilter': 'Driver',
  'optimizer.allDrivers': 'All drivers',
  'optimizer.day': 'Weekday',
  'optimizer.dayTours': '{count} tours',
  'optimizer.noDayTours': 'No tours planned for this selection.',
  'optimizer.familyTotals': 'Weekly totals by family',

  'optimizer.searchDuration': "Search duration",
  'optimizer.duration.30': "30 seconds · quick",
  'optimizer.duration.60': "1 minute · recommended",
  'optimizer.duration.120': "2 minutes · more thorough",
  'optimizer.durationNote': "Maximum time for the plan search. Queueing, road travel times and final checks take additional time. A longer search may find better plans but does not guarantee more savings.",
  'optimizer.queueNote': "This run is waiting for a free slot. Its search time has not started.",
  'optimizer.searchElapsed': "Elapsed {seconds} s · Search budget {budget} s",
  'optimizer.candidatesFound': "{count} possible tours found",
  'optimizer.finishingSearch': "The search budget is used up. Existing results are still being checked and saved.",
  'optimizer.backgroundNote': "You can close this window. The calculation continues in the background.",
  'optimizer.searchFinished': "Plan search: {seconds} s of at most {budget} s",
  'optimizer.searchFinishedLegacy': "Plan search: {seconds} s",
  'optimizer.searchTruncated': "Bounded search: not every possible tour was examined. A longer search may help; the global optimum is not guaranteed.",
  'optimizer.processTitle': "What happens during calculation?",
  'optimizer.phase.routing': "Loading road travel times",
  'optimizer.phaseNote.routing': "Travel times between locations are loaded. Cached connections are reused. The search budget has not started.",
  'optimizer.phase.starting': "Starting plan search",
  'optimizer.phaseNote.starting': "Travel times are ready. The group is being sent to the planner.",
  'optimizer.phase.candidates': "Building possible tours",
  'optimizer.phaseNote.candidates': "Tours are built from time windows, seats and driver availability. Own-family tours are considered first for every weekday.",
  'optimizer.phase.coverage': "Covering all child journeys",
  'optimizer.phaseNote.coverage': "A complete fallback plan is found first. The three alternatives are optimized only once every journey is covered together.",
  'optimizer.phase.solo': "Calculating solo comparisons",
  'optimizer.phaseNote.solo': "Driving time and outings when driving alone are calculated for each parent.",
  'optimizer.phase.baseline': "Searching for a short plan",
  'optimizer.phaseNote.baseline': "Total driving time is minimized. Individual parents may have more work.",
  'optimizer.phase.optimal': "Searching for an optimal plan",
  'optimizer.phaseNote.optimal': "Total driving time is minimized. Nobody may have more driving time or outings than alone; savings may be unequal.",
  'optimizer.phase.fair': "Searching for a fair plan",
  'optimizer.phaseNote.fair': "The burden relative to driving alone is distributed as evenly as possible.",
  'optimizer.phase.verifying': "Checking and preparing results",
  'optimizer.phaseNote.verifying': "The plans found are prepared for display. Verified results are retained even when the search budget is exhausted.",
  'optimizer.phase.completed': "Saving results",
  'optimizer.phaseNote.completed': "The search is complete. Verified plans are being saved.",

  'optimizer.fallback': 'Fallback plan',
  'optimizer.fallback.stale': 'Check coverage again',
  'optimizer.fallback.staleNote': 'Coverage is not confirmed for the current inputs. Please run the check again.',
  'optimizer.fallback.ready': 'All child journeys jointly covered',
  'optimizer.fallback.blocked': 'Group coverage not secured yet',
  'optimizer.fallback.blockedNote': 'The entire group remains blocked until a complete fallback plan exists. Add or adjust availability and check again. Nobody is automatically excluded.',
  'optimizer.fallback.unknown': 'Search limits were reached. This does not prove that full coverage is impossible.',
  'optimizer.fallback.diagnostic': 'Diagnostic result: {served} of {total} journeys. This is not a released group plan.',
  'optimizer.fallback.legacy': 'Historical result without a fallback check. Recalculate to check current readiness.',

  'optimizer.guidance.summary': '{served} of {total} journeys covered · {open} open',
  'optimizer.guidance.title': 'Ways to cover more journeys',
  'optimizer.guidance.open': 'open',
  'optimizer.guidance.pickupWindow': 'Required pickup',
  'optimizer.guidance.directWindow': 'Possible window for the direct journey',
  'optimizer.guidance.declared': 'Declared',
  'optimizer.guidance.none': 'no availability',
  'optimizer.guidance.localEvidence': 'Evidence for this combination; other combinations may face additional constraints.',
  'optimizer.guidance.legacy': 'Recalculate for specific guidance. This saved run has no diagnostics yet.',
  'optimizer.guidance.partial': 'Analysis is incomplete. Displayed improvements are verified; other possibilities have not been fully explored.',
  'optimizer.guidance.unavailable': 'Diagnostics are currently unavailable. The calculated plan remains available.',
  'optimizer.guidance.preserved': 'These comparisons preserve every previously covered journey. Individual suggestions are alternatives; do not add their improvements together.',
  'optimizer.guidance.package': 'Changes verified together',
  'optimizer.guidance.adjust': 'Adjust availability',
  'optimizer.guidance.covered': 'journeys covered',
  'optimizer.guidance.newWindow': 'Additional availability',
  'optimizer.guidance.extra': '{minutes} additional minutes of availability in total, rather than driving time alone.',
  'optimizer.guidance.newlyCovered': 'View {count} additional covered journeys',
  'optimizer.guidance.confirm': 'Availability must be confirmed – both the driver and car must actually be available.',
  'optimizer.guidance.next': 'Suggestions refer to this saved snapshot. Recalculate the weekly plan after confirmed availability changes.',
  'optimizer.guidance.noRemedy': 'The checked variants found no additional coverage. Consider further availability; this does not prove these journeys impossible.',
  'optimizer.planSection': 'Plan calculation',
  'optimizer.calculate': 'Check coverage and calculate plan',
  'optimizer.historyLoading': 'Loading saved plans…',
  'optimizer.starting': 'Starting calculation…',
  'optimizer.queued': 'Calculation queued…',
  'optimizer.solving': 'Calculating travel times and weekly plan…',
  'optimizer.planFailed': 'Plan calculation failed. Please try again.',
  'optimizer.history': 'All saved calculations',
  'optimizer.history.choose': 'Select a calculation',
  'optimizer.history.week': 'Week starting {date}',
  'optimizer.history.readOnly': 'Historical plan – view only',
  'optimizer.history.note': 'This plan shows the inputs and results saved at the time. It does not confirm current availability or coverage. Check the current inputs and calculate again before using it.',
  'optimizer.history.inputs': 'View saved inputs',
  'optimizer.history.unavailable': 'Not saved',
  'optimizer.status.QUEUED': 'Queued',
  'optimizer.status.RUNNING': 'Running',
  'optimizer.status.COMPLETED': 'Completed',
  'optimizer.status.FAILED': 'Failed',
  'optimizer.draftNote': 'A complete fallback plan is required before optimization. The entire group stays blocked until then. No rides are booked.',
  'optimizer.snapshot': 'Input snapshot from {date}. Subsequent changes are not included in this plan.',
  'optimizer.comparison': 'Comparison',
  'optimizer.baseline': 'Short plan',
  'optimizer.fair': 'Fair plan',
  'optimizer.optimal': 'Optimal plan',
  'optimizer.totalSavings': 'Total driving time saved',
  'optimizer.optimal.note': 'Save as much driving time as possible without any parent driving longer or more often than alone. Savings may differ between parents.',
  'optimizer.optimal.noSavings': 'No driving time savings were found under these conditions.',
  'optimizer.optimal.legacy': 'Recalculate to include the optimal plan. This older calculation does not contain this comparison.',
  'optimizer.optimal.missing_reference': 'Optimal plan unavailable: A complete solo comparison is missing for at least one parent.',
  'optimizer.optimal.infeasible': 'Optimal plan unavailable: None of the evaluated route combinations covers all trips without additional driving time or assignments for a parent.',
  'optimizer.optimal.unknown': 'Optimal plan not found within the time limit. Please recalculate.',
  'optimizer.optimal.not_calculated': 'Optimal plan not calculated yet. Please start the plan calculation.',
  'optimizer.coverage': 'Planned child trips',
  'optimizer.driving': 'Driving time',
  'optimizer.tours': 'Driving assignments',
  'optimizer.fairness': 'Unevenness ↓',
  'optimizer.openRequests': 'Open child trips',
  'optimizer.mon': 'Monday',
  'optimizer.tue': 'Tuesday',
  'optimizer.wed': 'Wednesday',
  'optimizer.thu': 'Thursday',
  'optimizer.fri': 'Friday',
  'optimizer.depart': 'Departure',
  'optimizer.return': 'Return',
  'optimizer.pickup': 'boards',
  'optimizer.dropoff': 'leaves',
  'optimizer.wait': 'Wait at appointment',
  'optimizer.transfers': 'Transfer drives',
  'optimizer.family': 'Family',
  'optimizer.coverageChecked': 'Complete fallback verified. Coverage is already secured; driving-time and fairness optimization is separate.',
  'optimizer.savings.title': 'Driving time and outings per parent · selected week',
  'optimizer.savings.explanation': 'How are savings calculated?',
  'optimizer.savings.note': 'Compared with a verified plan where each family drives only its own children. Parent assignments follow that reference plan, with availability times relaxed. Includes connecting drives, excludes waiting and stops. One continuous tour counts as one outing, even with multiple children or waiting before the return. Separate drop-off and pickup tours count as two outings. Redistribution can increase another parent’s driving time.',
  'optimizer.savings.tripsOne': '{count} outing',
  'optimizer.savings.tripsMany': '{count} outings',
  'optimizer.savings.tripsSavedOne': '{count} fewer outing',
  'optimizer.savings.tripsSavedMany': '{count} fewer outings',
  'optimizer.savings.tripsExtraOne': '{count} extra outing',
  'optimizer.savings.tripsExtraMany': '{count} extra outings',
  'optimizer.savings.tripsEqual': 'Same number of outings',
  'optimizer.savings.recalculateTrips': 'Recalculate this older plan to compare driving outings.',
  'optimizer.savings.person': 'Parent',
  'optimizer.savings.solo': 'Without carpooling',
  'optimizer.savings.planned': 'Selected plan',
  'optimizer.savings.saving': 'Saving / extra time',
  'optimizer.savings.unavailable': 'Not calculable',
  'optimizer.savings.saved': '{minutes} min saved',
  'optimizer.savings.extra': '{minutes} min extra',
  'optimizer.savings.recalculate': 'Individual values are missing from this older run. Please recalculate the plan.',
  'optimizer.boundedSearch': 'Bounded candidate search, no guaranteed global optimum.',
  'optimizer.title': 'Calculate weekly plan',
  'optimizer.description': 'Plan this group’s week and compare short, fair and optimal schedules.',
  'optimizer.week': 'Planning week',
  'optimizer.monday': 'Please select a Monday.',
  'optimizer.loading': 'Checking the weekly plan…',
  'optimizer.families': 'Families', 'optimizer.children': 'Children', 'optimizer.requests': 'Child trips',
  'optimizer.drivers': 'Drivers', 'optimizer.vehicles': 'Vehicles', 'optimizer.locations': 'Locations',
  'optimizer.fix': 'Please fix before calculating',
  'optimizer.calls': '{count} Mapbox requests per calculation or export',
  'optimizer.cost': 'The preview is free. Calculating or exporting fetches paid road travel times.',
  'optimizer.scope': 'Only this group is included. Other groups, live traffic and personal toll preferences are not considered. Calculated plans are saved with their original input snapshot.',
  'optimizer.download': 'Export JSON with travel times',
  'optimizer.running': 'Calculating travel times. This may take up to a minute.',
  'optimizer.downloaded': 'Download started. Import the file directly into the simulator.',
  'optimizer.failed': 'Export failed. Please try again.',
  'optimizer.refresh': 'Check preview again', 'optimizer.close': 'Close',
};
